<script>
import SimulatorStudentDetailQuestionComponent from '../features/SimulatorStudentDetailQuestionComponent';

export default {
  name: 'SimulatorStudentDetailQuestionView',
  components: {},
  extends: SimulatorStudentDetailQuestionComponent,
};
</script>
<template>
  <div
    v-loading="isLoading"
    class="sim_apply_question"
  >
    <!-- Enunciado -->
    <div class="sim_apply_question_block">
      <h4 class="sim_apply_question_title">
        <i class="uil uil-comment-question" /> Pregunta
      </h4>
      <div
        class="sim_apply_question_text"
        v-html="currentQuestion.value.name"
      />
    </div>

    <!-- Instrucciones -->
    <div
      v-if="currentQuestion.value.description"
      class="sim_apply_question_block"
    >
      <h4 class="sim_apply_question_title">
        <i class="uil uil-info-circle" /> Instrucciones
      </h4>
      <div
        class="sim_apply_question_text"
        v-html="currentQuestion.value.description"
      />
    </div>

    <!-- Respuestas -->
    <div class="sim_apply_question_block">
      <h4 class="sim_apply_question_title">
        <i class="uil uil-check-square" /> Respuestas
      </h4>

      <el-checkbox-group
        v-model="answersSelected"
        class="sim_apply_answers"
        @change="onChangeAnswer"
      >
        <el-checkbox
          v-for="answer in currentQuestion.value.simulatorAnswers"
          :key="answer.id"
          :value="answer.id"
          class="sim_apply_choice"
        >
          <span class="sim_apply_choice_body">
            <span
              class="sim_apply_choice_text"
              v-html="answer.description"
            />
          </span>
        </el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>
